import React, { useEffect, useState } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { ComponentProps } from '../../_WMS/FilterComponent/types'
import {
  createFilterValueWithDisplay,
  parseFilterValueWithDisplay
} from '../../../types/filters'
import { Warehouse } from '../../../interfaces/Warehouse/Warehouse'
import { getAllWarehouses } from '../api'

// Dropdown de Almacén para filtros de búsqueda que deben mostrar también los
// inactivos (hoy: admin de Zona y Posiciones). A propósito NO usa el caché
// Redux compartido (useWarehouses), que solo trae activos y es consumido por
// ~15 módulos que no deben ver inactivos — este componente hace su propio
// fetch, sin tocar ese caché.
export const WarehouseFilterDDL: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true,
  variant = 'outlined'
}) => {
  const [warehouses, setWarehouses] = useState<Warehouse[]>([])

  const fetchWarehouses = () => {
    getAllWarehouses().then((response) => setWarehouses(response.data?.items ?? []))
  }

  // Fetch inicial, para resolver rápido el display del valor ya seleccionado
  useEffect(() => {
    fetchWarehouses()
  }, [])

  const selectedId = parseFilterValueWithDisplay(value)?.id ?? -1

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selected = warehouses.find((w) => w.id === Number(event.target.value))
    if (!selected) return

    onChange({
      target: {
        value: createFilterValueWithDisplay(selected.id, selected.warehouseName),
        name: 'warehouseId'
      }
    } as React.ChangeEvent<HTMLInputElement>)
  }

  return (
    <TextField
      select
      fullWidth={fullWidth}
      variant={variant}
      size='small'
      value={selectedId}
      onChange={handleChange as any}
      // Refetch al abrir el dropdown (no solo al montar), para reflejar sin
      // recargar la página un cambio de estado hecho en el admin de Almacén.
      SelectProps={{ onOpen: fetchWarehouses }}
    >
      <MenuItem key={-1} value={-1}>
        Seleccionar Almacén...
      </MenuItem>
      {warehouses.map((w) => (
        <MenuItem key={w.id} value={w.id}>
          {w.warehouseName}
        </MenuItem>
      ))}
    </TextField>
  )
}
